var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTable(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.97597 10.9349H24.9983L23.9178 7.28484H6.08988L4.97597 10.9349ZM21.2762 13.1374H8.67243L8.33606 15.9148H21.6639L21.2762 13.1374ZM5.07608 23.6878L6.49567 13.1374H3.84638C3.42213 13.1374 3.07051 12.9582 2.79153 12.5998C2.51255 12.2412 2.4338 11.8523 2.55527 11.4331L4.12369 6.01676C4.20066 5.72399 4.36073 5.49084 4.60389 5.31731C4.84683 5.14356 5.11713 5.06525 5.41479 5.08238H24.5852C24.8829 5.08238 25.1532 5.16926 25.3961 5.34301C25.6393 5.51654 25.7993 5.74969 25.8763 6.04246L27.4447 11.4331C27.5662 11.8523 27.4874 12.2412 27.2085 12.5998C26.9295 12.9582 26.5779 13.1374 26.1536 13.1374H23.4529L24.8982 23.7212C24.9478 24.0275 24.8644 24.3039 24.6479 24.5501C24.4315 24.7966 24.159 24.9199 23.8304 24.9199C23.5565 24.9199 23.3225 24.8321 23.1282 24.6566C22.934 24.4813 22.8121 24.2567 22.7625 23.9828L21.9589 18.1173H8.01537L7.2118 24.0085C7.16219 24.2824 7.04028 24.5027 6.84606 24.6696C6.65184 24.8364 6.4178 24.9199 6.14394 24.9199C5.81535 24.9199 5.54283 24.7966 5.32636 24.5501C5.1099 24.3039 5.02647 24.0164 5.07608 23.6878Z",
    fill: "#334155"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.a00fecf07efbecbd172db59fbdfa94e0.svg";
export { ForwardRef as ReactComponent };